
//ハイパーリンクJS

jQuery(
function smooth_scroll() {
	$('a[href*="#"]').click(function () {//先頭一致では動かないので部分一致にする
		var headerHight=250; //ヘッダーの高さ指定
		var speed = 800;//スピード指定
		var href = $(this).attr('href').split("#").slice(-1);//クリックした要素のhrefを取得
		var target = $(href == "#" || href == "" ? 'html' : '#'+href);//移動先を指定
		var position = target.offset().top -70;//ポジションからヘッダーの高さ分引く
		var w = $(window).width();//レスポンシブ分岐用　ウインドウ幅取得
		if (w <= 734) {// 749だとずれる　//スマホ版のヘッダー高さ指定
			headerHight = 0;//SP版は固定ヘッダーなし
		}
		$("html, body").animate({
			scrollTop: position//スムーススクロール実行
		}, speed, "swing");
		return false;
	});
})



 function formSwitch() {
        hoge = document.getElementsByName('vary')
        if (hoge[0].checked) {
            // ペンダント実行
            document.getElementById('pendantList').style.display = "";
            document.getElementById('celingList').style.display = "none";
        } else if (hoge[1].checked) {
            // シーリング実行
            document.getElementById('pendantList').style.display = "none";
            document.getElementById('celingList').style.display = "";
        } else {
            document.getElementById('pendantList').style.display = "none";
            document.getElementById('celingList').style.display = "none";
        }
    }
    window.addEventListener('load', formSwitch());


$('button1').click(function(){
  
 $(this).text('').removeClass('success').addClass('loading').delay(1000).queue(function(){
    $(this).removeClass("loading").dequeue().addClass('success');
  });
  
});



function gate(){

   var UserInput = prompt("パスワードを入力してください","");
   
   if( /\W+/g.test(UserInput) ) {
      alert("半角英数字のみを入力して下さい。");
   }
   else if( UserInput != null ) {
      location.href = "https://bowks.design/collections/" + UserInput;
   }
}




